export default "__VITE_ASSET__DjpdGJCW__"